import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default {
  install(Vue) {
    /**
     * Get a correctly formatted date range to use in API requests.
     * @param {*} number Number of days, weeks years etc
     * @param {*} type Time category, minute, day, week etc
     * @param {*} number Time category, minute, day, week etc
     * @returns {start[string], end[string]}
     */
    Vue.prototype.$formatDateObject = (number, type, endAtDaysAgo = 0) => {
      return {
        start: dayjs().subtract(number, type).format("YYYY-MM-DD"),
        end: dayjs().subtract(endAtDaysAgo, "day").format("YYYY-MM-DD"),
      };
    };
  },
};
